import { render, staticRenderFns } from "./TabelaHistorico.vue?vue&type=template&id=9518d690&scoped=true"
import script from "./TabelaHistorico.vue?vue&type=script&lang=js"
export * from "./TabelaHistorico.vue?vue&type=script&lang=js"
import style0 from "./TabelaHistorico.vue?vue&type=style&index=0&id=9518d690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9518d690",
  null
  
)

export default component.exports